import React from 'react'
import Layout from '@primitives/layout'

export default () => <Layout style={{ width: 60 }} />



// WEBPACK FOOTER //
// ./components/Gutter.js